import { ECHOPAY_SVG } from "@/assets/svgs";
import { TabsProps, SideTabsProps } from "@/lib/types";

export const TABS: TabsProps[] = [
  {
    name: "Home",
    link: "/",
  },
  {
    name: "Merchants",
    link: "https://merchant.useresolva.io/",
  },
  {
    name: "Assets",
    link: "/",
  },
  {
    name: "Blog",
    link: "https://blog.useresolva.io/",
  },
];

export const MENUTABS: SideTabsProps[] = [
  {
    icon: ECHOPAY_SVG().analyticsIcon({
      className: "w-[18px] h-[18px] lg:w-[24px] lg:h-[24px]",
    }),
    name: "Analytics",
    link: "/analytics",
  },
  {
    icon: ECHOPAY_SVG().sendCircle({
      className: "w-[18px] h-[18px] lg:w-[23.5px] lg:h-[23.5px]",
    }),
    name: "Send",
    link: "/send",
  },
  {
    icon: ECHOPAY_SVG().receiveCircle({
      className: "w-[18px] h-[18px] lg:w-[23.5px] lg:h-[23.5px]",
    }),
    name: "Receive",
    link: "/receive",
  },
  {
    icon: ECHOPAY_SVG().tnxIcon({
      className: "w-[18px] h-[18px] lg:w-[24px] lg:h-[24px]",
    }),
    name: "Transactions",
    link: "/transactions",
  },
  {
    icon: ECHOPAY_SVG().groupIcon({
      className: "w-[18px] h-[18px] lg:w-[24px] lg:h-[24px]",
    }),
    name: "Beneficiaries",
    link: "/beneficiaries",
  },
];

export const SETTINGTABS: SideTabsProps[] = [
  {
    icon: ECHOPAY_SVG().gitfIcon({
      className: "w-[18px] h-[18px] lg:w-[24px] lg:h-[24px]",
    }),
    name: "Refer and Earn",
    link: "/referral",
  },
  {
    icon: ECHOPAY_SVG().settingsIcon({
      className: "w-[18px] h-[18px] lg:w-[24px] lg:h-[24px]",
    }),
    name: "Settings",
    link: "/settings",
  },
];

export const ASSETS = [
  { name: "USDT", link: "/usdt" },
  { name: "USDC", link: "/usdc" },
  { name: "BTC", link: "/btc" },
  { name: "SOL", link: "/sol" },
  { name: "ETH", link: "/eth" },
];
